import * as globals from '@wandb/weave/common/css/globals.styles';
import {Link} from '@wandb/weave/common/util/links';
import {IconRecentClock, IconRunningRepeat} from '@wandb/weave/components/Icon';
// eslint-disable-next-line wandb/no-deprecated-imports
import styled from 'styled-components';

import {cardContent, clampStyles} from './CommonCards.styles';

export const CardHeaderRow = styled.div`
  display: flex;
  flex-direction: row;
`;
CardHeaderRow.displayName = 'S.CardHeaderRow';

export const CardHeader = styled.div`
  ${clampStyles}
  display: block;
  text-overflow: ellipsis;
  color: ${globals.MOON_950};
  font-family: Source Sans Pro;
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 32px;
  flex: 1;
`;
CardHeader.displayName = 'S.CardHeader';

export const CardMeta = styled.div`
  font-size: calc(${globals.fontSizeStandard} * 0.75);
  margin-top: calc(${globals.spu} * 2);
  display: flex;
  align-items: center;
`;
CardMeta.displayName = 'S.CardMeta';

export const CardMetaLeft = styled.div`
  display: flex;
  align-items: center;
`;
CardMetaLeft.displayName = 'S.CardMetaLeft';

export const CardMetaRight = styled.div`
  display: flex;
  align-items: center;
`;
CardMetaRight.displayName = 'S.CardMetaRight';

export const RunsIcon = styled(IconRunningRepeat)`
  width: 14px;
  height: 14px;
  margin-right: 4px;
  margin-left: 12px;
  color: ${globals.GOLD_550};
`;
RunsIcon.displayName = 'S.RunsIcon';

export const SkeletonTextWrapper = styled.div`
  gap: 10px;
  display: flex;
  flex-direction: column;
`;
SkeletonTextWrapper.displayName = 'S.SkeletonTextWrapper';

export const UpdatedAtIcon = styled(IconRecentClock)`
  width: 12px;
  height: 12px;
  margin-right: 4px;
  color: ${globals.GREEN_500};
`;
UpdatedAtIcon.displayName = 'S.UpdatedAtIcon';

export const ClampedLine = styled.span`
  ${clampStyles};
`;
ClampedLine.displayName = 'S.ClampedLine';

export const Card = styled(Link)`
  ${cardContent}
`;
Card.displayName = 'S.Card';
